import React, { useState, useEffect } from 'react';
import plusIcon from '../../assets/images/add-icon-min.svg';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import backArrow from '../../assets/images/arrow.svg';
import { useSelector, useDispatch } from 'react-redux';
import CircularLoader from '../../utils/Loaders/CircularLoader';
import { toast } from 'react-toastify';
import { Get } from '../../Api/ApiMethods.js';
import { 
    getMyVehicleListUrl,
    getVehicleTypesUrl
 } from '../../Routes/ApiRoutes';

export default function VehicleList() {
    const token = useSelector((state) => state.auth.isSignedIn);
    const dispatch = useDispatch();
    const {pathname} = useLocation();
    const history = useHistory();
    const {id} = useParams();
    history.listen((location, action) => {
        if(action !== "PUSH"){
           history.goBack();
        }
    });
    
    const [vehicleList, setVehicleList] = useState([]);
    const [vehicleType, setVehicleType] = useState(null);
    const [loader, setLoader] = useState(false);
    const [tittle, setTittle] = useState('');
    
    useEffect(() => {
        if(pathname === '/profile/vehicleList'){
            setTittle('Added vehicle');
        }else{
            setTittle('Select vehicle');
        }
    }, []);

    useEffect(() => {
        fetchVehicleType();
    }, []);

    useEffect(() => {
        fetchVehicleList();
    }, []);

    const fetchVehicleType = () => {
        try {
            Get(getVehicleTypesUrl, token)
            .then(res => {
                if(res.status === 200){
                    setVehicleType(res.data)
                }
            })
            .catch(error => {
                console.log(error);
                setLoader(false);
            })
          }catch (error) {
            console.log(error);
            setLoader(false);
        }
    }

    const fetchVehicleList = () => {
       setLoader(true);
        try {
            Get(getMyVehicleListUrl, token, 'pageNo=1&pageSize=50')
            .then(res => {
                if(res.status === 200){
                    setVehicleList(res.data.rows);
                    setLoader(false);
                }
            })
            .catch(error => {
                toast.error(error.error);
            })
          }catch (error) {
            toast.error(error.error);
        }
    }

    const handleSelectVehicle = (e,item) => {
        e.preventDefault();
        setLoader(true);
        dispatch({
            type: 'VEHICLE_ID',
            payload: item.id,
          });      
        history.push({
            pathname: `/booking/listSubscription/${id}/${item.id}`,
        });
    }
    
    console.log('useselector', useSelector((state) => state.vehicleId))
    return (
        <>
        {loader && <CircularLoader />}
            <section className="Added-vehicles-wrapper">
                <div className="container">
                    <div className="Added-vehicles">
                    <div className="row no-gutters">
                        <div className="col-md-12 col-sm-12 col-12 padding-rt">
                            <div className="generate">
                                <h3><img onClick={() => {
                                    if(pathname === '/profile/vehicleList'){
                                        history.push(`/profile`);
                                    }else{
                                        history.push(`/home`);
                                    }
                                }} className="mr-2 cursorP" src={backArrow} />{tittle}</h3>
                                <p>Add vehicle<img onClick={() => {
                                    if(pathname === '/profile/vehicleList'){
                                        history.push(`/profile/vehicleList/addVehicle`);
                                    }else{
                                        history.push(`/booking/addVehicle/${id}`);
                                    }
                                }} className="mr-2 cursorP" src={plusIcon} /></p>
                            </div>
                        </div>
                    </div>
                    <div className="row no-gutters">
                        {vehicleList.length > 0 ? vehicleList.map((item) => {
                            return(
                                <div key={item.id} onClick={(e) => {
                                    if(pathname === '/profile/vehicleList'){
                                        
                                    }else{
                                        handleSelectVehicle(e,item)};
                                    }
                                } className="col-md-6 col-sm-6 padding-rt">
                                    <div className="booking-info-wrapper">
                                        <div className="booking-date">
                                            <p> Vehicle Information</p>
                                        </div>
                                        <div className="space-details">
                                            <div className="Space-no">
                                                <p>Type: <span>{vehicleType && vehicleType.map((i => i.id === item.vehicle_type && i.type_name ))}</span></p>
                                                <p>Registration number : <span> {item.reg_no}</span></p>
                                                <p>Dimension: <span> {item.length + ' x ' + item.width + ' ft'}</span></p>
                                                <p>Driver licence</p>
                                                <p>
                                                    <img className='deleIcon' src={item.registration_doc} />
                                                </p>
                                                <p>Vehicle image</p>
                                                <p>
                                                    <img className='deleIcon' src={item.vehicle_image} />
                                                </p>
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                            )
                        }) :
                        <div className="col-12 padding-rt">
                            <div style={{textAlign:'center', padding:'200px 0'}}>
                                <p>No vehicle added!</p>
                                <p>Add one to continue your space</p>
                            </div>
                        </div>
                    }
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}
